import axios from 'axios'
import store from '@/vuex/store'
import config from '../../config'
import toastr from 'toastr'
import { get } from 'lodash'

export const baseUrl = config.dev.env.API_URL.replace(/"(.*)"/, '$1')

axios.defaults.baseURL = baseUrl

axios.interceptors.request.use(function (req) {
  const token = store.getters['auth/token']

  if (token) {
    req.headers.common = Object.assign({}, req.headers.common, { Authorization: `Bearer ${token}` })
  }

  return req
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Processes the global response intereceptors
axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 422) {
        if (get(error, 'response.data.errors.slug[0]')) {
          toastr.warning('O valor informado para o campo slug já está em uso.', 'URL da página do site!')
        } else {
          toastr.error('Foram encontrados alguns erros no formulário, por favor, revise-o e tente novamente.', 'Erro!')
        }
        /**
         * Validation error
         * As the default behaviour we will add the error to a "component" with the name of the field
         */
        try {
          store.dispatch('errors/clearError', ['UnprocessableEntity'])
          store.dispatch('errors/setError', ['UnprocessableEntity', error.response.data])
        } catch (e) {
          store.dispatch('errors/pushGlobalError', [
            { message: 'Houve um erro ao identificar o problema com o upload' }
          ])
        }
      } else if (error.response.status === 500) {
        toastr.error('Ocorreu um erro interno, contate o suporte ou tente novamente mais tarde.', 'Erro!')
      }
    }

    if (!error.response && error.request) {
      const errorMessage = {
        message: 'Houve um erro na servidor.'
      }
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      store.dispatch('errors/pushGlobalError', [errorMessage])
    }

    // Do something with response error
    return Promise.reject(error)
  })

window.axios = axios

export default axios



// WEBPACK FOOTER //
// ./src/services/axios.js